// @flow

import React from 'react';
import type { Node } from 'react';
import classNames from 'classnames';

import { boxesCls, boxesWrapCls, boxActiveCls } from 'shared_components/common/boxes/Boxes.less';

type Props = {
  children: Node,
  wrap?: boolean,
};

export { boxActiveCls };

/**
 * Boxes
 *
 * @param {Props} props
 */
export const Boxes = ({ children, wrap = false }: Props): Node => {
  return <div className={classNames(boxesCls, wrap && boxesWrapCls)}>{children}</div>;
};
